/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sharechannelinstagrambio3Inputs */

const en_sharechannelinstagrambio3 = /** @type {(inputs: Sharechannelinstagrambio3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram bio`)
};

const de_sharechannelinstagrambio3 = /** @type {(inputs: Sharechannelinstagrambio3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Instagram-Bio`)
};

/**
* | output |
* | --- |
* | "Instagram bio" |
*
* @param {Sharechannelinstagrambio3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const sharechannelinstagrambio3 = /** @type {((inputs?: Sharechannelinstagrambio3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sharechannelinstagrambio3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sharechannelinstagrambio3(inputs)
	return de_sharechannelinstagrambio3(inputs)
});
export { sharechannelinstagrambio3 as "shareChannelInstagramBio" }